export default __webpack_public_path__ + "465e0c50d08e3b0fe7dacb5daca45342.png";